// 分享相关
export const GET_SHARE_PAGE_USERINFO  = `/api/news/getSharePageUserInfo`
export const GET_HOT_COMMENT  = `/api/news/getHotComment`
export const GET_HOT_COMMENT_NEW  = `/api/recommand/comments`
export const GET_RECOMMAND_ARTICLES  = `/api/recommand/articles`
export const GET_CONTENT  = `/api/news/content`
export const GET_SHARE_CONTENT = `/api/share/getShareContent`
export const GET_HIGH_SHARE_ARTICLES = `/api/share/getHighShareArticle`
export const GET_TRPC_RECOMMAND_ARTICLES = `/api/recommand/trpcArticles`
export const GET_INTEREST_RECOMMEND_ARTICLES = `/api/recommand/interestRecommend`
// 换链
export const GET_SHARE_BY_TOKEN = `/api/share/getShareByToken`

// 上报
export const GET_REPORT_DATA = `/api/stat/reportData`
export const POST_REPORT_DATA_BULK = `/api/stat/reportData/bulk`


export const GET_HOT_RANK = `/api/search/hotrank`

// SMP 实验
export const GET_SMP_UI_DATA = `/api/smp/getSmpUIData`

export const POST_MATCH_PROFILE_LIST = `/api/gsp/matchprofileproxy`

// 视频
export const GET_VIDEO_INFO  = `/api/video/getVideoInfo`
export const GET_VIDEO_COLLECTION  = `/api/video/getVideoCollection`
export const GET_RECOMMAND_VIDEOS  = `/api/recommand/videos`
export const GET_TRPC_RECOMMAND_VIDEOS  = `/api/recommand/trpcVideos`

// 短内容
export const GET_SHORT_CONTENTS  = `/api/recommand/shortContents`

// 电商裂变
// export const GET_ACTIVITY_LIST = `https://upage.sparta.html5.qq.com/activity`
// export const GET_COMMODITY_DETAIL = `https://upage.sparta.html5.qq.com/commodity`
// export const GET_ASSISTANCE_INFO = `https://upage.sparta.html5.qq.com/assistanceInfo`
// export const POST_ASSISTANCE = `https://upage.sparta.html5.qq.com/reportAssistant`
// export const GET_CLIPBOARD = `https://upage.sparta.html5.qq.com/ug-aes-encrypt`
// export const GET_SIGN = `https://upage.sparta.html5.qq.com/sign`
// export const GET_USER_LEVEL = `https://upage.sparta.html5.qq.com/userLevel`
// export const GET_JUMP_URL = `https://upage.sparta.html5.qq.com/jumpUrl`
// export const GET_STAT = `https://upage.sparta.html5.qq.com/ug-common-data`

export const GET_ACTIVITY_LIST = `/activity`
export const GET_COMMODITY_DETAIL = `/commodity`
export const GET_ASSISTANCE_INFO = `/assistanceInfo`
export const POST_ASSISTANCE = `/reportAssistant`
export const GET_CLIPBOARD = `/ug-aes-encrypt`
export const GET_SIGN = `/sign`
export const GET_USER_LEVEL = `/userLevel`
export const GET_JUMP_URL = `/jumpUrl`
export const GET_STAT = `/ug-common-data`